import http from "../http"

/**
 * 用户登录  获取虫情孢子 token
 * @param param
 * @returns {*}
 */
export function userLogin(param) {
  return http({
    url: '/api/v2.0/entrance/user/userLogin',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 *获取用户设备
 * @returns {*}
 */
export function spUserDevice() {
  return http({
    url: '/api/v2.0/entrance/device/getsysUserDevice',
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 获取设备实时数据
 * @param deviceAddrs
 * @returns {*}
 */
export function spRealDataTime(deviceAddrs) {
  return http({
    url: '/api/v2.0/entrance/device/getRealTimeData?deviceAddrs=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 获取孢子设备详情
 * @param deviceAddrs
 * @returns {*}
 */
export function sporeDeviceInfo(deviceAddrs) {
  return http({
    url: '/api/v2.0/spore/device/getBtchDeviceDO?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 获取孢子设备自动模式时间
 * @param deviceAddrs
 * @returns {*}
 */
export function sporeAutoMode(deviceAddrs) {
  return http({
    url: '/api/v2.0/spore/device/getSporeAutoMode?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 孢子设备手动自动模式切换
 * @param param
 * @returns {*}
 */
export function deviceModel(param) {
  return http({
    url: '/api/v2.0/spore/device/deviceMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 向孢子设备下发命令
 * @param param
 * @returns {*}
 */
export function deviceOper(param) {
  return http({
    url: '/api/v2.0/spore/device/deviceOper',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 修改孢子设备自动模式时间
 * @param param
 * @returns {*}
 */
export function modSporeAutoMode(param) {
  return http({
    url: '/api/v2.0/spore/device/modSporeAutoMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 获取孢子设备分析报表记录
 * @param beginTime
 * @param endTime
 * @param deviceAddr
 * @returns {*}
 */
export function sporeDataAndAIByDO(beginTime, endTime, deviceAddr) {
  return http({
    url: '/api/v2.0/spore/deviceData/getSporeDataAndSporeDataAIByDO?beginTime=' + beginTime + '&endTime=' + endTime + '&deviceAddr=' + deviceAddr + '&pages=1&limit=1000',
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 获取虫情设备详情
 * @param deviceAddrs
 * @returns {*}
 */
export function bathDeviceDo(deviceAddrs) {
  return http({
    url: '/api/v2.0/worm/device/getBtchDeviceDO?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 *获取虫情设备自动模式时间
 * @param deviceAddrs
 * @returns {*}
 */
export function wormAutoMode(deviceAddrs) {
  return http({
    url: '/api/v2.0/worm/device/getWormAutoMode?deviceAddr=' + deviceAddrs,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 *虫情设备手自动模式切换
 * @param param
 * @returns {*}
 */
export function wormMode(param) {
  return http({
    url: '/api/v2.0/worm/device/deviceOper/wormMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 虫情设备下发命令
 * @param param
 * @returns {*}
 */
export function wormOper(param) {
  return http({
    url: '/api/v2.0/worm/device/deviceOper/wormOper',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 修改虫情设备自动模式时间
 * @param param
 * @returns {*}
 */
export function modWormAutoMode(param) {
  return http({
    url: '/api/v2.0/worm/device/modWormAutoMode',
    method: 'post',
    data: param,
    urlType: 'sporePest'
  })
}

/**
 * 获取虫情设备分析报表
 * @param deviceAddr
 * @param beginTime
 * @param endTime
 * @returns {*}
 */
export function getWormDataList(deviceAddr, beginTime, endTime) {
  return http({
    url: '/api/v2.0/worm/deviceData/getWormDataList?deviceAddr=' + deviceAddr + '&beginTime=' + beginTime + '&endTime=' + endTime + '&pages=1&limit=1000',
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 虫情区域统计
 * @param groupId
 * @param beginTime
 * @param endTime
 * @returns {*}
 */
export function getWormStatisticsByGroup(groupId, beginTime, endTime) {
  return http({
    url: '/api/v2.0/worm/deviceData/getWormStatisticsByGroup?groupId=' + groupId + '&beginTime=' + beginTime + '&endTime=' + endTime,
    method: 'get',
    urlType: 'sporePest'
  })
}

/**
 * 获取用户区域
 * @returns {*}
 */
export function getsysUserGroup() {
  return http({
    url: '/api/v2.0/entrance/group/getsysUserGroup',
    method: 'get',
    urlType: 'sporePest'
  })
}





// WEBPACK FOOTER //
// ./src/until/api/SporePest.js